import * as React from "react";

interface KeyboardProps {
    // Handler that is called when a key is pressed
    onKeyDown?: (e: React.KeyboardEvent) => void;
    // Handler that is called when a key is released
    onKeyUp?: (e: React.KeyboardEvent) => void;
    isDisabled?: boolean;
}

interface KeyboardResult {
    keyboardProps: React.HTMLAttributes<HTMLElement>;
}

export function useKeyboard(props: KeyboardProps): KeyboardResult {
    return {
        keyboardProps: props.isDisabled
            ? {}
            : {
                  onKeyDown: props.onKeyDown,
                  onKeyUp: props.onKeyUp,
              },
    };
}
